module.exports = __webpack_public_path__ + "img/crusher.b8a2dda2.png";